import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/survey', [
    {
      path: '/participation/:id(\\d+)?',
      name: 'survey-participation-list',
      component: () => import('@/views/survey/SurveyParticipationList.vue'),
    },
    {
      path: '/:participantId(\\d+)/:path(.*)*',
      name: 'survey-report',
      component: () => import('@/views/survey/SurveyReport.vue'),
    },
    ...withPrefix('/management', [
      {
        path: '',
        name: 'survey-management',
        redirect: { name: 'survey-list' },
      },
      {
        path: '/list',
        name: 'survey-list',
        component: () => import('@/views/survey/SurveyList.vue'),
      },
      {
        path: '/create',
        name: 'survey-create',
        component: () => import('@/views/survey/SurveyCreate.vue'),
      },
      {
        path: '/:id(\\d+)',
        name: 'survey-edit',
        component: () => import('@/views/survey/SurveyEdit.vue'),
        redirect: { name: 'survey-edit-details' },
        children: [
          {
            path: 'details',
            name: 'survey-edit-details',
            component: () =>
              import('@/components/survey/management/SurveyForm.vue'),
          },
          {
            path: 'questions',
            name: 'survey-edit-questions',
            component: () =>
              import('@/components/survey/management/SurveyQuestions.vue'),
          },
          {
            path: 'layout',
            name: 'survey-edit-layout',
            component: () =>
              import('@/components/survey/management/SurveyLayout.vue'),
          },
          {
            path: 'participation',
            name: 'survey-edit-participation',
            component: () =>
              import('@/components/survey/management/SurveyParticipation.vue'),
          },
          {
            path: 'preview/:path(.*)*',
            name: 'survey-edit-preview',
            component: () =>
              import('@/components/survey/management/SurveyPreview.vue'),
          },
          {
            path: 'state',
            name: 'survey-edit-state',
            component: () =>
              import('@/components/survey/management/SurveyState.vue'),
          },
          {
            path: 'dashboardtiles',
            name: 'survey-dashboard-tiles',
            component: () =>
              import('@/components/survey/management/SurveyDashboardTiles.vue'),
          },
        ],
      },
      ...withPrefix('/group', [
        {
          path: '',
          name: 'survey-group',
          redirect: { name: 'survey-group-list' },
        },
        {
          path: '/list',
          name: 'survey-group-list',
          component: () => import('@/views/survey/SurveyGroupList.vue'),
        },
        {
          path: '/create',
          name: 'survey-group-create',
          component: () => import('@/views/survey/SurveyGroupCreate.vue'),
        },
        {
          path: '/:id(\\d+)',
          name: 'survey-group-edit',
          component: () => import('@/views/survey/SurveyGroupEdit.vue'),
          redirect: { name: 'survey-group-edit-details' },
          children: [
            {
              path: 'details',
              name: 'survey-group-edit-details',
              component: () =>
                import('@/components/survey/management/SurveyGroupForm.vue'),
            },
            {
              path: 'dashboardtiles',
              name: 'survey-group-dashboard-tiles',
              component: () =>
                import(
                  '@/components/survey/management/SurveyGroupDashboardTiles.vue'
                ),
            },
            {
              path: 'worksheets',
              name: 'survey-group-edit-worksheets',
              component: () =>
                import(
                  '@/components/survey/management/SurveyGroupWorksheetList.vue'
                ),
            },
          ],
        },
      ]),
    ]),
  ]);
};
